import { render, staticRenderFns } from "./AgeValue.vue?vue&type=template&id=e0a8ec56&scoped=true"
import script from "./AgeValue.vue?vue&type=script&lang=js"
export * from "./AgeValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a8ec56",
  null
  
)

export default component.exports